export default __webpack_public_path__ + "static/media/qubitlabs.7c23d1bc.png";